import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-confirm-modal',
  template: `
  <div class="modal-header">
    <h5 class="modal-title pull-left">{{header}}</h5>
    <button type="button" class="close pull-right" aria-label="Close" (click)="decline()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <p>{{prompt}}</p>
    <button type="button" class="btn btn-primary" (click)="confirm()">Yes</button>
    <button type="button" class="btn btn-danger" (click)="decline()">No</button>
  </div>`
})
export class QuestionModalComponent implements OnInit {
  prompt: string;
  header: string;
  callback: (result: string) => void;
  private closing = false;

  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit() {
    console.log('Modal initialized with header:', this.header);
  }

  confirm() {
    if (this.closing) return;
    this.closing = true;

    console.log('Confirm clicked');

    // Store callback locally to avoid access after modal is destroyed
    const cb = this.callback;
    if (cb) {
      cb('yes');
    }

    // Use local reference for bsModalRef
    const modalRef = this.bsModalRef;
    setTimeout(() => {
      modalRef.hide();
    }, 0);
  }

  decline() {
    if (this.closing) return;
    this.closing = true;

    console.log('Decline clicked');

    // Store callback locally to avoid access after modal is destroyed
    const cb = this.callback;
    if (cb) {
      cb('no');
    }

    // Use local reference for bsModalRef
    const modalRef = this.bsModalRef;
    setTimeout(() => {
      modalRef.hide();
    }, 0);
  }
}

